export default "__VITE_ASSET__C5dXj61u__"